import React from "react";
import { Controller } from "react-hook-form";
import { Col, Label } from "reactstrap";
import { Stack } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { AntInput } from "../../CommonElements/AntInput";
import { validateSaudiNationalId } from "./validationUtils";

export const NationalIdField = ({
  control,
  errors,
  colSize = "md-4",
  required = true,
  name = "national_id",
  labelKey = "NATIONAL_ID"
}) => {
  const { t } = useTranslation();

  return (
    <Col {...{ [colSize.split('-')[0]]: colSize.split('-')[1] }}>
      <Stack gap={1} className="mb-3">
        <Label for={name} className={`fw-bold ${required ? 'required' : ''}`}>
          {t(labelKey)}
        </Label>
        <Controller
          name={name}
          control={control}
          rules={{
            ...(required && { required: t("FIELD_REQUIRED") }),
            validate: (value) => validateSaudiNationalId(value, t),
          }}
          render={({ field }) => (
            <AntInput
              id={name}
              name={name}
              {...field}
              status={errors[name] ? "error" : undefined}
            />
          )}
        />
        {errors[name] && (
          <div className="text-danger mt-1">{errors[name].message}</div>
        )}
      </Stack>
    </Col>
  );
};
